import React from 'react'
import { motion } from 'framer-motion'
import invariant from 'tiny-invariant'
import { BLOB_PATH, CIRCLE_PATH } from './helpers'

export const BlotToChat = () => {
  const rotationWrapperTimes = keyframesToTimes([0, 0.99, 2.87])
  const scaleWrapperTimes = keyframesToTimes([0, 0.33, 1.27, 2.35])
  return (
    <motion.g
      style={{ originX: 'center', originY: 'center' }}
      animate={{ rotate: [0, 390.5, 405], scale: [1, 0.84, 0.84, 0.68] }}
      transition={{
        rotate: { times: rotationWrapperTimes, delay: 0.23, duration: 2.87 },
        scale: { times: scaleWrapperTimes, duration: 2.35 },
      }}
    >
      <BaseBlobToChat fill='rgb(var(--primary-color))' />
      <BaseBlobToChat fill='white' opacities={[0, 0, 0, 0, 1]} />
    </motion.g>
  )
}

const MESSAGE_PATH =
  'M 44.2753 14.4157 c 0 0 23.402 23.2038 23.402 23.2038 c 0 0 -15.8692 0.911 -15.8692 0.911 c 0 0 -14.1805 14.1244 -18.927 18.927 c -5.505 5.449 -9.3206 0.2713 -9.3206 0.2713 c 0 0 -7.1063 -6.932 -12.1855 -12.0872 c -5.0793 -5.1551 0.0075 -9.1101 0.0075 -9.1101 c 0 0 18.5934 -17.6079 23.6822 -22.111 c 5.0888 -4.5031 9.2106 -0.0048 9.2106 -0.0048 z'

const BaseBlobToChat = ({ fill, opacities }: { fill: string; opacities?: number[] }) => {
  const times = keyframesToTimes([0, 0.33, 0.58, 1.23, 1.58])
  const pathKeyframes = [CIRCLE_PATH, BLOB_PATH, BLOB_PATH, CIRCLE_PATH, MESSAGE_PATH]
  return (
    <motion.path
      fill={fill}
      animate={{
        d: pathKeyframes,
        opacity: opacities,
      }}
      transition={{ times, duration: 1.58 }}
    />
  )
}

const keyframesToTimes = (keyframes: number[]) => {
  const lastKeyframe = keyframes.at(-1)
  invariant(lastKeyframe, 'Keyframes array must not be empty')
  return keyframes.map(keyframe => keyframe / lastKeyframe)
}
